/**
 * Knitmas advent calendar PDP — behaviour for sections/knitmas-pdp-main.liquid.
 *
 * Only loaded by that section. Everything it touches outside the section
 * (the slider snippet, the sticky bar, goshop-faq) is reached through markup
 * that already exists on those components; none of them are modified.
 *
 * Runs on DOMContentLoaded rather than straight away: this file is deferred,
 * and the slider snippet mounts Splide in its own DOMContentLoaded handler,
 * registered earlier in the page, so window.productMainSlider exists by the
 * time ours runs.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return withCommas;
        case 'amount_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default:
          return withCommas + '.' + parts[1];
      }
    });
  }

  /* "Pre-order · $X" follows the quantity. */
  function initTotal(root) {
    var qty = root.querySelector('[data-kpdp-qty]');
    var total = root.querySelector('[data-kpdp-total]');
    var price = parseInt(root.dataset.price, 10);
    if (!qty || !total || isNaN(price)) return;

    function update() {
      var quantity = Math.max(1, parseInt(qty.value, 10) || 1);
      total.textContent = formatMoney(price * quantity, root.dataset.moneyFormat);
    }

    qty.addEventListener('change', update);
    qty.addEventListener('input', update);
  }

  /*
   * The shared sticky bar shows whenever the main button is out of view —
   * including before the shopper has reached it. Here it waits until the
   * button has been scrolled past. Its labels are normally switched to
   * "Pre-order" by buy-buttons.liquid, which this page does not render.
   */
  function initSticky(root) {
    var sticky = root.querySelector('.sticky-cta-container');
    var cta = root.querySelector('[data-kpdp-cta]');
    if (!sticky || !cta) return;

    var label = root.dataset.ctaLabel;
    sticky.querySelectorAll('[data-default-label]').forEach(function (el) {
      el.style.display = 'none';
    });
    sticky.querySelectorAll('[data-preorder-label]').forEach(function (el) {
      if (label) el.textContent = label;
      el.style.display = '';
    });

    var image = sticky.querySelector('img');
    if (image) image.setAttribute('alt', '');

    var proof = root.dataset.stickyProof;
    var priceContainer = sticky.querySelector('#sticky-price-container');
    if (proof && priceContainer) {
      var line = document.createElement('p');
      line.className = 'kpdp-sticky__proof';
      line.textContent = proof;
      priceContainer.appendChild(line);
    }

    /*
     * A scroll listener, not an IntersectionObserver: a jump straight past the
     * button (fast fling, restored scroll position) goes from "below the
     * viewport" to "above it" without ever intersecting, so no entry fires.
     */
    var queued = false;
    function update() {
      queued = false;
      root.classList.toggle('kpdp--past-cta', cta.getBoundingClientRect().bottom < 0);
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* The badges go inside #main-slider, owned by the slider snippet. */
  function initGallery(root) {
    var overlay = root.querySelector('[data-kpdp-gallery-overlay]');
    var mainSlider = document.getElementById('main-slider');
    if (!overlay || !mainSlider) return;

    mainSlider.appendChild(overlay);
    overlay.hidden = false;
  }

  function initKlaviyo(root) {
    var desktop = window.matchMedia('(min-width: 768px)');
    root.querySelectorAll('[data-kpdp-klaviyo]').forEach(function (button) {
      button.addEventListener('click', function () {
        var formId = desktop.matches ? button.dataset.formDesktop : button.dataset.formMobile;
        if (!formId) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });
  }

  /*
   * goshop-faq lets several answers stay open. The spec wants one at a time,
   * so opening one closes the others in the same accordion, through the
   * section's own toggle so its icon and height stay in sync.
   */
  function initFaqOneOpen() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.faq-section [data-faq-toggle]');
      if (!toggle || toggle.getAttribute('aria-expanded') !== 'true') return;

      var accordion = toggle.closest('[id^="faq-accordion-"]');
      if (!accordion) return;

      accordion.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach(function (other) {
        if (other !== toggle) other.click();
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-kpdp-main]').forEach(function (root) {
      if (root.dataset.kpdpReady) return;
      root.dataset.kpdpReady = 'true';
      initTotal(root);
      initSticky(root);
      initGallery(root);
      initKlaviyo(root);
    });
  }

  initFaqOneOpen();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
